export default __webpack_public_path__ + "static/media/raise-hand-off.01ceb108.svg";